// types
import { type ModuleType as UserAppClient } from "./_definitions"
import { type State } from "../../types"

export const userAppClientSelector = (state: State): UserAppClient => state.userAppClient
